import React, { useEffect, useState } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { BillDataTable } from "./DataTable";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { useBillRechargeLogModel } from "../billRechargeLogModel";
import { PageHeader } from "./PageHeader";
import { labelsType } from "@/views/cash/pay/cashPayModel";
import { orgService } from "@/views/base/org/orgService";
import { beService } from "@/views/base/be/beService";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import useGlobalModel from "@/model/globalModel";
import { useRechargeModel } from "@/views/account/customerManage/view/detail/recharge/rechargeModel";
import { ApprovalDrawer } from "./ApprovalDrawer";
import useNavModel, { RouterParamType } from "@/model/navModel";

export const BillRechargeLog = () => {
    const {
        setBeDs,
        billSummaryData,
        setOrgDs,
        selectedData,
        setWriteoffDrawerVisible,
        loadData,
        setPayMethodLabels,
        loadCustomer,
        billCustomerExport,
        selectedRowKeys,
        setApprovalDrawerVisible,
        searchParam,
        setSearchParam
    } = useBillRechargeLogModel();
    const { getSelectedDict } = useGlobalModel(() => []);
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);


    useEffect(() => {
        let obj: labelsType = {}
        orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
        beService.beDs({}).then(ds => setBeDs(ds))
        getSelectedDict(DictCodeEnmu.SETTLE_TYPE).forEach(item => {
            obj[item.value] = item.label
        })
        setPayMethodLabels(obj);
        loadCustomer()
        if(detailsInfo&&detailsInfo?.id=='待审核'){
            setSearchParam({...searchParam,statusList:0})
            loadData({ pageNum: 1 }, { ...searchParam, statusList:0 }).then()
        }
        else{
        loadData({ pageNum: 1 }).then()
    }
    }, [detailsInfo]);

    const desc: IDescription[] = [
        {
            label: "充值总额",
            value: billSummaryData.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },
    ]
    const onApproval = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData?.status === 0) {
                setApprovalDrawerVisible(true);
            } else {
                message.error("该条记录不可审核!");
            }
        } else {
            message.error("请选择待审核记录!");
        }
    }
    const action = (
        <>
            <div>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={billCustomerExport}
                >
                    导出
                </Button>
                <YhAuth resCode={ResourceAuthEnum.ACC_C_VW_CHARG_AUDIT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onApproval}
                >
                    审核
                </Button>
            </YhAuth>
            </div>

        </>
    );
    return (
        <>
            <PageHeader />
            <YhBox title={"充值记录总览"} descriptions={desc} action={action}>
                <BillDataTable />
            </YhBox>
            <ApprovalDrawer />
        </>
    )
}
